exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n  .stripeTerms___2jH8h {\n    font-size: 24px;\n  }\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/stripe.less"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;GACjB;CACF","file":"stripe.less","sourcesContent":["@media (max-width: 767px) {\n  .stripeTerms {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"stripeTerms": "stripeTerms___2jH8h"
};